// Soft-deleted rows are recoverable for this many days, then the daily purge
// hard-deletes them. Shared so the frontend "days remaining" countdown and the
// backend purge cutoff can never promise different recovery windows.
export const TRASH_RETENTION_DAYS = 30;
export const TRASH_MAX_PAGE_SIZE = 200;
// Single source of truth for the set of soft-deletable entity types. Every
// handler literal, DTO, GraphQL model, invalidation map and trash-page switch
// derives from this, so adding a module is one edit here (plus its handler) and
// a typo or a missed place fails the type-check instead of failing at runtime.
export const TRASH_ENTITY_TYPE_LIST = [
    "climateAction",
    "project",
    "task",
    "indicator",
    "inventory",
    "municipalProperty",
    "municipalPropertyRegister",
    "municipalPropertyYear",
    "scenarioModel",
    "dataRequest",
];
